export default __webpack_public_path__ + "static/scam-latitude-protect-alert-1-b3f4ab90d93d5574e9b669926f44f989.webp";